import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import PostListLayer from "../../components/Post/PostListLayer";


const PostList = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Pending Post" />

        {/* UsersListLayer */}
        <PostListLayer />

      </MasterLayout>

    </>
  );
};

export default PostList;
